export default "__VITE_ASSET__Cv2UMRe7__"